/**
 * Detect page scrolling, add `-scrolled` class to `<BODY>` when the page is scrolled (scrollTop > 0).
 */
import emitter from '../../utils/emitter';

export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  'use strict';

  let passiveIfSupported = false;
  let initialized = false;
  let scrolling = false;
  let scrollendTimeout = null;
  let triggerTimeout = null;

  // detect passive feature
  try {
    const options = {
      // This function will be called when the browser attempts to access the passive property.
      get passive() { 
        passiveIfSupported = {
          passive: true
        };
        return false;
      }
    };

    window.addEventListener('test', null, options);
    window.removeEventListener('test', null, options);
  } catch(err) {
    // ignore
  }

  return async () => {
    if (initialized) {
      // do not runs more then once
      return;
    }

    const $body = $('body');
    initialized = true;

    const updateScrolledClass = async () => {
      $body.toggleClass('-scrolled', window.pageYOffset > 0);
    };

    
    //const scrolled = utilities.debounce(() => {
    const scrolled = async () => {
      if (triggerTimeout) {
        window.cancelAnimationFrame(triggerTimeout);
        triggerTimeout = null;
      }
      
      triggerTimeout = window.requestAnimationFrame(() => {
        if (scrollendTimeout) {
          window.clearTimeout(scrollendTimeout);
          scrollendTimeout = null;
        }

        updateScrolledClass();
        
        if (!scrolling) {
          scrolling = true;

          emitter.fire('scrollstart', {
            scrollTop: $(window).scrollTop()
          });
        }

        scrollendTimeout = window.setTimeout(() => {
          scrollendTimeout = null;
          if (scrolling) {
            scrolling = false;
            emitter.fire('scrollend', {
              scrollTop: $(window).scrollTop()
            });
          }
        }, 100);

        emitter.fire('scroll', {
          scrollTop: $(window).scrollTop()
        });
      });
    };
    //}, 13);

    window.addEventListener('scroll', function(event) {
      scrolled();
    }, passiveIfSupported );

    // initial update on DOM ready
    $(() => {
      updateScrolledClass();
    });
  };

})(jQuery, window);